module.exports = __webpack_public_path__ + "static/img/9areaA_03.5a8a489.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/9areaA_03.png
// module id = 1067
// module chunks = 1